export default __webpack_public_path__ + "static/media/successfully.d7de33a8.png";